import { apiClient } from '../../gateways/api'
import type { FetchHoofdleidingGlobalsLists } from '../types/FetchHoofdleidingGlobalsLists'

export { fetchHoofdleidingGlobalsLists, initialState }

const initialState: FetchHoofdleidingGlobalsLists = {
  data: {
    gemeenten: [],
    typeWerkTypes: [],
  },
}

const fetchHoofdleidingGlobalsLists = async (): Promise<
  FetchHoofdleidingGlobalsLists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/hoofdleiding/lists/globals',
    method: 'GET',
  })
  return data
}
